import type { ReactNode } from 'react'

/** Bordered card shell with a titled header — the action log's outer chrome. */
export const ActionLogCard = ({
  title,
  children,
}: {
  title: string
  children: ReactNode
}) => (
  <div className="mt-4 overflow-hidden rounded-xl bg-white shadow-card">
    <div className="px-5 py-4">
      <span className="text-lg font-semibold text-primary">{title}</span>
    </div>
    <div className="px-5 pb-5 pt-0">{children}</div>
  </div>
)
